import React from 'react';
import { Row } from 'react-bootstrap';
import {
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  buildWhereForDates,
  YupNumeric,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FieldSelectMaterial, FieldSelectWasteReceptionPoint } from 'shared-pages';
import * as Yup from 'yup';

import FsWasteTranType from 'shared-pages/components/field-select/fs-WasteTransationType';
import { useRootStore } from 'store';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  console.log('$$$ -------- filters');
  // Φτιάξε το where για το graphql
  let where = {};

  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ transactionCode: likeObj }],
      };
    }
    if (values.wastereceptionpointId) {
      where = { ...where, wastereceptionpointId: values.wastereceptionpointId };
    } else {
      where = { wastereceptionpointId: -1 }; // Required Field
    }
    if (values.materialId) {
      where = { ...where, materialId: values.materialId };
    }
    if (values.wasteTransactionTypeId) {
      where = { ...where, wasteTransactionTypeId: values.wasteTransactionTypeId };
    }
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'transactionDate'),
      };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false }) => {
  //
  const { t } = useTranslation();
  const { appStore } = useRootStore();
  //
  const formShape = {
    wastereceptionpointId: YupNumeric.required(t('Υποχρεωτικό πεδίο')),
  };
  const validationSchema = Yup.object().shape(formShape);
  //
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    wastereceptionpointId: initialValues?.wastereceptionpointId ?? undefined,
    materialId: initialValues?.materialId ?? undefined,
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    wasteTransactionTypeId: initialValues?.wasteTransactionTypeId ?? undefined,
  };

  const collectorId = appStore.isCollector ? appStore.associatedId : undefined;

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
      validationSchema={validationSchema}
    >
      <Row>
        <FieldDateRanger as={FormCol} label="Κίνηση από" name="startDate" name2="endDate" />
        <FieldSelectWasteReceptionPoint
          label="Αποθηκευτικός Χώρος"
          as={FormCol}
          collectorId={collectorId}
          required
        />
        <FieldSelectMaterial as={FormCol} />
      </Row>
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση ( Κωδικός Κίνησης )')}
          type="search"
          disable={disable}
        />
        <FsWasteTranType as={FormCol} label="Τύπος Κίνησης" name="wasteTransactionTypeId" />
      </Row>
    </FormFilterCard>
  );
};
